import type { ReactNode } from 'react';

export function DesktopContainer({ children }: { children: ReactNode }) {
  return (
    <div className="max-w-screen-3xl relative mx-auto flex min-h-screen w-full flex-col overflow-hidden">
      {children}
    </div>
  );
}
